var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "modal",
    {
      attrs: { size: "md" },
      on: {
        close: function($event) {
          _vm.$emit("close")
        }
      }
    },
    [
      _c("template", { slot: "header" }, [
        _c(
          "div",
          { staticClass: "header" },
          [
            _vm._v("\n      Avaliação\n      "),
            _c("stars", {
              attrs: { slot: "header", rating: _vm.feedback.rating },
              slot: "header"
            })
          ],
          1
        )
      ]),
      _vm._v(" "),
      _c("template", { slot: "body" }, [
        _c("small", [_vm._v('"' + _vm._s(_vm.feedback.description) + '"')])
      ]),
      _vm._v(" "),
      _c("template", { slot: "footer" }, [
        _c(
          "div",
          {
            staticClass: "btn bg-purple-outline",
            on: {
              click: function($event) {
                _vm.$emit("close")
              }
            }
          },
          [_vm._v("fechar")]
        )
      ])
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-27bdfe5a", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-27bdfe5a","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/_Shared/Professionals/Feedbacks/FullFeedback.vue
// module id = null
// module chunks = 